import React from 'react';
import { Network, TxChain } from '@types';
import useGetSrcChainExplorerUrl from '@hooks/useGetExplorerUrl';
import { shortenAddress } from '@lib/utils';

interface Props {
  amount: string;
  currencySymbol: string;
  network: Network;
  chain: TxChain | null;
  txnHash: string;
  betaTx: boolean;
}

function DepositInfo({
  amount,
  currencySymbol,
  network,
  chain,
  txnHash,
  betaTx,
}: Props) {
  const getExplorerUrl = useGetSrcChainExplorerUrl();
  const explorerUrl = chain ? getExplorerUrl(network, chain) : '';

  return (
    <div className="text-left">
      <p className="text-body">
        {`${
          betaTx ? 'Initiated transfer of' : 'Deposit of'
        } ${amount} ${currencySymbol}`}
      </p>
      <p className="text-smallRegular">
        Transaction ID:{' '}
        <a
          href={explorerUrl + txnHash}
          className="text-blue"
          target="_blank"
          rel="noreferrer"
        >
          {shortenAddress(txnHash)}
        </a>
      </p>
    </div>
  );
}

export default DepositInfo;
